export default {
    // 数量精度
    quantityPrecision: 5, //260410改回5位
};